import { useCallback } from "react";
import Checkbox from "../checkbox";

function ComboBox({
    name,
    items,
    selected,
    toggleItem,
    className,
    minimum,
}: {
    name: string;
    items: { Id: number; Description?: string; Icon?: string; showIcon?: boolean }[];
    selected: number[];
    toggleItem: (id: number) => void;
    className?: string;
    minimum?: number;
}) {
    const getStreamName = useCallback((streamId) => {
        switch (streamId) {
            case 7:
                return "x-twitter";
            case 8:
                return "facebook";
            case 9:
                return "instagram";
            case 10:
                return "youtube";
            case 11:
                return "linkedin";
            case 12:
                return "tiktok";
        }
    }, []);
    if (undefined === minimum) {
        minimum = 0;
    }
    return (
        <div className={className ? className : "combo-box"}>
            {items &&
                items.map((x) => {
                    return (
                        <div className="input-group" key={x.Id}>
                            <label htmlFor={`${name}-${x.Id}`}>
                                {x.showIcon && <i className={`fab fa-${getStreamName(x.Id)}`}></i>}
                                {x.Description}
                            </label>
                            <Checkbox id={`${name}-${x.Id}`} checked={selected.includes(x.Id)} onChange={() => toggleItem(x.Id)} disabled={selected.length === minimum && selected.includes(x.Id)} />
                        </div>
                    );
                })}
        </div>
    );
}

export default ComboBox;
